import {Feature} from 'ms-frontend-shared';

const environment: {[key: string]: string | undefined} = import.meta.env;

export const initEnvironmentVariables = async (): Promise<void> => {
	if (import.meta.env.MODE !== 'test') {
		const response = await fetch('/env.json');
		if (response.status != 200) {
			throw new Error((await response.text()) ?? response.statusText);
		}
		const runtimeEnv = (await response.json()) as Record<string, string>;
		for (const [key, value] of Object.entries(runtimeEnv)) {
			environment[key] = value;
		}
	}
	return Promise.resolve();
};

export const env = (key: string, fallback?: string): string => {
	const value = environment[key];
	if (value !== undefined) {
		return value;
	} else if (fallback !== undefined) {
		return fallback;
	} else {
		throw new Error(`missing environment variable: "${key}"`);
	}
};

export const envInt = (key: string, fallback?: number): number => {
	const value = env(key, fallback?.toString());
	return Number.parseInt(value, 10);
};

export const envBool = (key: string, fallback?: boolean): boolean => {
	const value = env(key, fallback?.toString());
	return value === 'true';
};

export function isFeatureEnabled(feature: Feature): boolean {
	const disabledFeatures = env('VITE_DISABLED_FEATURES', '')
		.split(',')
		.map((f) => f.trim());
	return !disabledFeatures.includes(feature);
}

export function isCnHost() {
	return envBool('VITE_CN_HOST', false);
}
